import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { VEHICLES as STATIC_VEHICLES } from "@/data/vehicles";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const VehiclesContext = createContext({ vehicles: STATIC_VEHICLES, loading: false, getBySlug: () => undefined, refresh: () => {} });

export const VehiclesProvider = ({ children }) => {
  // Initialize with static data so the UI renders instantly, then hydrate from API.
  const [vehicles, setVehicles] = useState(STATIC_VEHICLES);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/vehicles`);
      if (!res.ok) throw new Error("fetch failed");
      const data = await res.json();
      if (Array.isArray(data)) setVehicles(data);
    } catch (e) {
      // keep static fallback
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const getBySlug = useCallback((slug) => vehicles.find((v) => v.slug === slug), [vehicles]);

  return (
    <VehiclesContext.Provider value={{ vehicles, loading, getBySlug, refresh }}>
      {children}
    </VehiclesContext.Provider>
  );
};

export const useVehicles = () => useContext(VehiclesContext);
